import {z} from 'zod';

import {MESSAGING_ALLOWLIST_LIMITS} from '../constants/MESSAGING_ALLOWLIST_LIMITS';

const allowlistChannelSchema = z.object({
  enabled: z.boolean(),
  patterns: z
    .array(
      z.object({
        value: z.string().max(MESSAGING_ALLOWLIST_LIMITS.MAX_PATTERN_LENGTH),
      })
    )
    .max(MESSAGING_ALLOWLIST_LIMITS.MAX_PATTERNS_PER_CHANNEL),
});

export const MessagingAllowlistFormSchema = z.object({
  email: allowlistChannelSchema,
  sms: allowlistChannelSchema,
});
export type MessagingAllowlistFormSchemaType = z.infer<typeof MessagingAllowlistFormSchema>;
